enum Roles {
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  CONTRACTOR = "CONTRACTOR",
}
export default Roles;
